// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store/index'
import less from 'less'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import Clipboards from 'clipboard'
import './dialog'
import baseurl from './Common'
import i18n from './i18n/i18n'
import './assets/css/global.css'; // 引入全局样式表




Vue.prototype.$ajax = axios
Vue.prototype.Clipboard=Clipboards;
Vue.prototype.baseurl=baseurl;

import moment from 'moment'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-directive-image-previewer/dist/assets/style.css'

//全局css
import './assets/css/base.css'
import './assets/css/font.css'
import animated from 'animate.css' 


Vue.config.productionTip = false
 //全局注册axios
Vue.prototype.$http = axios
//全局注册moment
Vue.prototype.moment = moment
Vue.use(ElementUI)
Vue.use(less)
Vue.use(VueDirectiveImagePreviewer)
Vue.use(i18n)
Vue.use(animated)
Vue.filter('dateFormat',function(dateStr,pattern='YYYY-MM-DD'){
  return moment(dateStr).format(pattern)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

//请求拦截器
axios.interceptors.request.use(config => {
    // console.log(config)
    // 为请求头对象，添加token验证的Authorization字段
    config.headers.token = window.sessionStorage.getItem('token')
    // 最后必须return config
    return config
  }, error => {
  // 请求错误
    return Promise.reject(error);
  });
 
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
//     if (sessionStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
//       next();
//     } else {
//       next({
//         path: '/Login', // 未登录则跳转至login页面
//         query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
//         });
//     }
//   } else {
//     next();
//   }
// });

  


// WEBPACK FOOTER //
// ./src/main.js